import { Fade, IconButton } from '@telescope/cassini-ui';
import { useParentPosition, useScroll } from 'hooks';
import { useRef } from 'react';
import { isIframed } from 'utils';
import { ChevronUpIcon } from './icons';

const BOTTOM_OFFSET = 70;

interface BackToTopButtonProps {
  isVisible: boolean;
}

export const BackToTopButton = ({ isVisible }: BackToTopButtonProps) => {
  const { scrollToTop } = useScroll();
  const { vHeight, iframeBottom } = useParentPosition();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonHeight = buttonRef.current?.offsetHeight || 0;
  const positionFromTop = window.innerHeight + (vHeight - iframeBottom) - BOTTOM_OFFSET - buttonHeight;

  const positionProps = isIframed()
    ? { top: 0, style: { transform: `translateY(${positionFromTop}px)` } }
    : {
        bottom: BOTTOM_OFFSET,
      };
  return (
    <Fade className="BackToTopButton" in={isVisible} unmountOnExit={true}>
      <IconButton
        className="BackToTopButton__button"
        ref={buttonRef}
        filter="auto"
        dropShadow="2px 2px 4px rgba(0, 0, 0, 0.7)"
        aria-label="Back to top"
        icon={
          <ChevronUpIcon
            className="BackToTopButton__icon"
            sx={{
              '.circle': { fill: 'var(--cassini-colors-back-to-top-bg)' },
              '.border': { fill: 'var(--cassini-colors-back-to-top-border)' },
              '.caret': { fill: 'var(--cassini-colors-back-to-top-caret)' },
            }}
          />
        }
        right={30}
        width={['60px', '70px']}
        height={['60px', '70px']}
        position="fixed"
        variant="link"
        onClick={scrollToTop}
        {...positionProps}
      />
    </Fade>
  );
};
